import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import './LegalPage.css';

export default function DatenschutzPage() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <Link to="/profile" className="legal-back">
          <ChevronLeft size={20} /> Zurück
        </Link>
        <h1 className="legal-title">Datenschutzerklärung</h1>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Datenschutz auf einen Blick</h2>
          <h3>Allgemeine Hinweise</h3>
          <p>
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit deinen
            personenbezogenen Daten passiert, wenn du unsere Website besuchst. Personenbezogene
            Daten sind alle Daten, mit denen du persönlich identifiziert werden kannst.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Verantwortliche Stelle</h2>
          <p>
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
            LetsCareers<br />
            Musterstraße 1<br />
            67655 Kaiserslautern<br />
            E-Mail: <a href="mailto:noreply@letscareers.de">noreply@letscareers.de</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Welche Daten wir erheben</h2>
          <p>
            Wir erheben und verarbeiten folgende Kategorien personenbezogener Daten:
          </p>
          <ul>
            <li>Name und E-Mail-Adresse (bei Registrierung)</li>
            <li>Profilinformationen (Standort, Fähigkeiten, Lebenslauf)</li>
            <li>Bewerbungsaktivitäten (gespeicherte und beworbene Stellen)</li>
            <li>Technische Daten (IP-Adresse, Browser-Typ, Zugriffszeiten)</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Zweck der Datenverarbeitung</h2>
          <p>
            Wir verarbeiten deine Daten ausschließlich für folgende Zwecke:
          </p>
          <ul>
            <li>Bereitstellung und Betrieb der LetsCareers-Plattform</li>
            <li>Vermittlung zwischen Jobsuchenden und Arbeitgebern</li>
            <li>Kommunikation via Chat und E-Mail</li>
            <li>Verbesserung unserer Dienste</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. Rechtsgrundlage</h2>
          <p>
            Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)
            sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Plattformverbesserung).
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Datenspeicherung und Löschung</h2>
          <p>
            Deine Daten werden gespeichert, solange dein Account aktiv ist. Du kannst deinen Account
            und alle gespeicherten Daten jederzeit in den Profileinstellungen unter "Account löschen"
            endgültig löschen. Nach der Löschung werden alle personenbezogenen Daten innerhalb von
            30 Tagen aus unseren Systemen entfernt.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Deine Rechte</h2>
          <p>
            Du hast jederzeit das Recht auf:
          </p>
          <ul>
            <li>Auskunft über deine gespeicherten Daten (Art. 15 DSGVO)</li>
            <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
            <li>Löschung deiner Daten (Art. 17 DSGVO)</li>
            <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
            <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
            <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          </ul>
          <p>
            Für die Ausübung deiner Rechte wende dich an:{' '}
            <a href="mailto:noreply@letscareers.de">noreply@letscareers.de</a>
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Cookies und lokale Speicherung</h2>
          <p>
            Wir verwenden keine Tracking-Cookies. Für den Betrieb der App speichern wir
            ausschließlich technisch notwendige Daten (Authentifizierungstoken) im lokalen
            Speicher deines Geräts.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Beschwerderecht</h2>
          <p>
            Du hast das Recht, dich bei einer Datenschutzaufsichtsbehörde zu beschweren.
            Die zuständige Behörde für Rheinland-Pfalz ist der Landesbeauftragte für den
            Datenschutz und die Informationsfreiheit Rheinland-Pfalz.
          </p>
        </section>

        <p className="legal-updated">Stand: Mai 2026</p>
      </div>
    </div>
  );
}
